/*
 * Aglika cart nudges: the "add" buttons of snippets/aglika-cart-nudges.liquid.
 * Adds the product to the cart and lets the theme redraw the cart.
 */
(function () {
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-aglika-nudge-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    const choice = button.closest('.aglika-nudge').querySelector('[data-aglika-nudge-variant]');
    const id = Number(choice ? choice.value : button.dataset.id);
    const quantity = Number(button.dataset.quantity) || 1;
    if (!id) return;

    button.disabled = true;
    const routes = (window.theme && window.theme.routes) || {};

    fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id, quantity}]}),
    })
      .then((response) => response.json())
      .then((result) => {
        // An error response (for example not enough stock) carries a status and a description
        if (result.status) {
          button.disabled = false;
          button.closest('.aglika-nudge').querySelector('.aglika-nudge__text').textContent = result.description || result.message;
          return;
        }
        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart();
        } else {
          window.location.reload();
        }
      })
      .catch(() => {
        button.disabled = false;
      });
  });
})();
